import { getWorkspaceID } from '../utils'
import { useUserInfo } from '../api/hooks/user/useUserInfo'
import { useWorkspaces } from '../api/hooks/workspaces/useWorkspaces'

const TOUR_WORKSPACE_NAME = 'Tour Scoop'

export const useIsTourWorkspace = () => {
    const { user } = useUserInfo()
    const { workspaces } = useWorkspaces()
    const workspaceID = getWorkspaceID()

    if (user?.defaultTour) {
        return user.defaultTour === workspaceID
    }

    return workspaces.find((w) => w.name === TOUR_WORKSPACE_NAME)?.workspaceID === workspaceID
}
